import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { Deposito, Ubicacion } from '../types/almacen.types';

interface AlmacenStore {
  depositos: Deposito[];
  ubicaciones: Ubicacion[];
  loading: boolean;
  error: string | null;

  setDepositos: (depositos: Deposito[]) => void;
  setUbicaciones: (ubicaciones: Ubicacion[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

export const useAlmacenStore = create<AlmacenStore>()(
  devtools(
    (set) => ({
      depositos: [],
      ubicaciones: [],
      loading: false,
      error: null,

      setDepositos: (depositos) => set({ depositos }),
      setUbicaciones: (ubicaciones) => set({ ubicaciones }),
      setLoading: (loading) => set({ loading }),
      setError: (error) => set({ error }),
    }),
    { name: 'AlmacenStore' }
  )
);
